import { render, staticRenderFns } from "./RoutePlanUnitSettings.vue?vue&type=template&id=1b3f3788&scoped=true"
import script from "./RoutePlanUnitSettings.vue?vue&type=script&lang=js"
export * from "./RoutePlanUnitSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f3788",
  null
  
)

export default component.exports